import { FC } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';

import { useHost } from 'src/providers/HostProvider';
import { getCurrentParkingPlace } from 'src/store/parking/selectors';
import { getUserPermissions } from 'src/store/user/selectors';

import { ParkingBottomSheet } from './ReservedByEmployee/ParkingBottomSheet';

export const ParkingBookingBottomSheet: FC = () => {
  const { host } = useHost();
  const parking = useSelector(getCurrentParkingPlace);
  const data = useSelector(getUserPermissions);

  if (!data?.employeeNumber || !host) return null;

  return createPortal(
    <ParkingBottomSheet
      parking={parking}
      employeeNumber={data.employeeNumber}
      spaces={data.spaces}
      adminSpaces={data.adminSpaces}
    />,
    host,
  );
};
